<div class="mat-typography">
  <h2 mat-dialog-title>
    <b
      ><span fxFlex class="primary-color">{{ data.dialogTitle }}</span></b
    >
  </h2>
  <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 0px;"></div>
  <div mat-dialog-content class="scrollable dialog-content-wrapper" style="margin-top: 16px; margin-bottom: 16px; margin-left: 2px; margin-right: 2px;">
    <div *ngIf="showSpinner">
      <p style="text-align: center"><mat-spinner color="accent" diameter="36"></mat-spinner></p>
    </div>
    <div *ngIf="!showSpinner">
      <!-- Credit Card Title and Title Error -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.paymentDetail.paymentType == paymentType.CreditCard"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.credit-card.title">payment-confirmation-dialog.form.credit-card.title</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.paymentDetail.paymentType == paymentType.CreditCard"
      >
        <b
          ><span i18n="@@payment-confirmation-dialog.form.credit-card.error-title"
            >payment-confirmation-dialog.form.credit-card.error-title</span
          ></b
        >
      </div>
      <!-- PayPal -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.paymentDetail.paymentType == paymentType.PayPal"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.paypal.title">payment-confirmation-dialog.form.paypal.title</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.paymentDetail.paymentType == paymentType.PayPal"
      >
        <b
          ><span i18n="@@payment-confirmation-dialog.form.paypal.error-title"
            >payment-confirmation-dialog.form.paypal.error-title</span
          ></b
        >
      </div>
      <!-- Apple Pay -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.paymentDetail.paymentType == paymentType.ApplePay"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.applepay.title">payment-confirmation-dialog.form.applepay.title</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.paymentDetail.paymentType == paymentType.ApplePay"
      >
        <b
          ><span i18n="@@payment-confirmation-dialog.form.applepay.error-title"
            >payment-confirmation-dialog.form.applepay.error-title</span
          ></b
        >
      </div>
      <!-- ACH Title and Title Error -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing highlighted-display-text"
        *ngIf="!showError && data.paymentDetail.paymentType === paymentType.ElectronicCheck"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.ach.title">payment-confirmation-dialog.form.ach.title</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color"
        *ngIf="showError && data.paymentDetail.paymentType === paymentType.ElectronicCheck"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.ach.error-title">payment-confirmation-dialog.form.ach.error-title</span></b>
      </div>
      <!-- Notices & Errors -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing"
        *ngIf="!showError"
      >
        <b><span i18n="@@payment-confirmation-dialog.form.notice">payment-confirmation-dialog.form.notice</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color "
        *ngIf="showError"
      >
        <b><span i18n="@@payment-confirmation-dialog.error.1">payment-confirmation-dialog.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing warning-color "
        *ngIf="showError"
      >
        <b><span i18n="@@payment-confirmation-dialog.error.2">payment-confirmation-dialog.error.2</span></b>
      </div>
      <!-- response form -->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.response-message.label"
            placeholder="payment-confirmation-dialog.form.response-message.label"
            type="text"
            [value]="data.paymentDetail.responseMessage"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.confirmation-code.label"
            placeholder="payment-confirmation-dialog.form.confirmation-code.label"
            type="text"
            [value]="data.paymentDetail.confirmationCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType === paymentType.ElectronicCheck"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.ach.confirmation-number.label"
            placeholder="payment-confirmation-dialog.form.ach.confirmation-number.label"
            type="text"
            [value]="data.paymentDetail.confirmationCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.payment-amount.label"
            placeholder="payment-confirmation-dialog.form.payment-amount.label"
            type="text"
            [value]="data.paymentDetail.paymentAmount | currency"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.response-code.label"
            placeholder="payment-confirmation-dialog.form.response-code.label"
            type="text"
            [value]="data.paymentDetail.responseCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType && data.paymentDetail.paymentType == paymentType.CreditCard"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.credit-card-number.label"
            placeholder="payment-confirmation-dialog.form.credit-card-number.label"
            type="text"
            [value]="maskCreditCardNumber('123456789012' + data.paymentDetail.lastFourCreditCard)"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType && data.paymentDetail.paymentType == paymentType.CreditCard"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.credit-card-expiration.label"
            placeholder="payment-confirmation-dialog.form.credit-card-expiration.label"
            type="text"
            [value]=" ('0' + data.paymentDetail.creditCardExpMonth).slice(-2) + '/' + data.paymentDetail.creditCardExpYear"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.paymentType !== paymentType.PayPal"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.name.label"
            placeholder="payment-confirmation-dialog.form.name.label"
            type="text"
            [value]="data.paymentDetail.name"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.paymentType !== paymentType.PayPal"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.address-line-1.label"
            placeholder="payment-confirmation-dialog.form.address-line-1.label"
            type="text"
            [value]="data.paymentDetail.addressLine1"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="display-text"
      *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.addressLine2"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.address-line-2.label"
            placeholder="payment-confirmation-dialog.form.address-line-2.label"
            type="text"
            [value]="data.paymentDetail.addressLine2"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.paymentType !== paymentType.PayPal"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.city.label"
            placeholder="payment-confirmation-dialog.form.city.label"
            type="text"
            [value]="data.paymentDetail.city"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.paymentType !== paymentType.PayPal"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.state.label"
            placeholder="payment-confirmation-dialog.form.state.label"
            type="text"
            [value]="data.paymentDetail.state"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text"
        *ngIf="data.paymentDetail.paymentType !== paymentType.ElectronicCheck && data.paymentDetail.paymentType !== paymentType.PayPal"
      >
        <mat-form-field fxFlex="90%" fxFlex.lt-md="100%">
          <input
            matInput
            i18n-placeholder="@@payment-confirmation-dialog.form.zip-code.label"
            placeholder="payment-confirmation-dialog.form.zip-code.label"
            type="text"
            [value]="data.paymentDetail.zipCode"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" class="display-text normal-paragraph-spacing" *ngIf="isMobileDevice()">
        <span class="flex-spacer"></span>
        <button
          mat-flat-button
          color="primary"
          (click)="onCloseClick()"
          *ngIf="!showSpinner"
          i18n="@@payment-confirmation-dialog.close-button.label"
        >
          payment-confirmation-dialog.close-button.label
        </button>
      </div>
      <div fxLayout="row" class="display-text large-paragraph-spacing" *ngIf="isMobileDevice()">
        &nbsp;
      </div>
      <div fxLayout="row" class="display-text large-paragraph-spacing" *ngIf="isMobileDevice()">
        &nbsp;
      </div>
    </div>
  </div>
  <div mat-dialog-actions *ngIf="!isMobileDevice()">
    <span class="flex-spacer"></span>
    <button
      mat-flat-button
      color="primary"
      (click)="onCloseClick()"
      *ngIf="!showSpinner"
      i18n="@@payment-confirmation-dialog.close-button.label"
    >
      payment-confirmation-dialog.close-button.label
    </button>
  </div>
</div>
